import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import confirmBrandActions from '../actions/confirmBrand';
import base64 from 'base-64';

function getBrandSwitchRedirect(store, action) {
    const {primarySite, currency, bankingCountry} = action.payload;

    request.get(`/${config.url_prefix}/api/getSiteRedirect?site=${primarySite.name}`)
        .end((error, response) => {
            if (error) {
                store.dispatch(confirmBrandActions.brandServiceError('internal.server.error'));
            } else {
                try {
                    const res = JSON.parse(response.text);
                    let redirectLink = res.redirectLink;
                    const prefillValue = base64.encode(`currency=${currency}&bankingCountry=${bankingCountry}`);
                    redirectLink = (redirectLink.indexOf('=') > -1) ? `${redirectLink}&brandSwitchPrefill=${prefillValue}` : `${redirectLink}?brandSwitchPrefill=${prefillValue}`

                    window.location = redirectLink;
                } catch (exp) {
                    store.dispatch(confirmBrandActions.brandServiceError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getBrandSwitchRedirect;
